import Vue from 'vue'
import ApiClientsService from 'js/services/api/api-clients.js'

import NewBalanceAccountSummary from './_account-summary'

import template from './index.pug'

// @vue/component
export default Vue.extend({
  name: 'new-balance-page',
  template: template(),

  components: {
    NewBalanceAccountSummary
  },

  data() {
    return {
      QR_MEDIA_TYPE: '2',

      paymentMedias: []
    }
  },

  computed: {
    account() {
      const qr = this.paymentMedias.find(
        paymentMedia => paymentMedia.mediaType === this.QR_MEDIA_TYPE
      )

      if (qr) {
        qr.rutPassport = this.$currentAccount.rut
      }

      return qr
    },

    mediaProfiles() {
      if (this.$administrativeArea && this.$administrativeArea.media_profiles) {
        const mediaProfiles = {}

        this.$administrativeArea.media_profiles.forEach(mediaProfile => {
          mediaProfiles[mediaProfile.code] = mediaProfile.name
        })

        return mediaProfiles
      }

      return {}
    },

    hasPaymentMedias() {
      return this.paymentMedias.length > 0
    }
  },

  watch: {
    $currentAccount() {
      this.requestPaymentMedias()
    }
  },

  created() {
    this.requestPaymentMedias()
  },

  methods: {
    async requestPaymentMedias() {
      if (!this.$currentAccount) { return }

      const params = {
        administrative_area_id: this.$currentAccount.administrative_area_id,
        rut: this.$currentAccount.rut
      }

      ApiClientsService.clientMediaInfo(params).then(response => {
        this.paymentMedias = _.map(response.data, media => ({
          ...media,
          balance: media.Balance,
          mediaCode: media.CardSerialNumber,
          mediaType: media.MediaType,
          profile: Number(media.Profile)
        }))
      })
    },

    reloadView() {
      Vue.store.dispatch('loadCurrentUser').then(() => {
        this.requestPaymentMedias()
      })
    }
  }
})
